import styled from 'styled-components';

export const CarouselContainer = styled.div`
    width: 100%;
    height: 350px;
    perspective: 1200px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: visible;

    @media (max-width: 768px) {
        height: 250px;
        perspective: 800px;
    }
`;

export const CarouselStage = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    transform-style: preserve-3d;
    transition: transform 1s cubic-bezier(0.23, 1, 0.32, 1);
    will-change: transform;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CarouselItem = styled.div`
    position: absolute;
    width: 200px;
    height: 200px;
    transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: transform, opacity;
    background: ${({ $active, $isDarkMode }) =>
        $active
            ? $isDarkMode
                ? '#0b0c10'
                : '#e3e4e9'
            : 'transparent'};
    transform: rotateY(${({ $rotate }) => $rotate}deg)
        translateZ(
            ${({ $radius, $active }) =>
                $active ? $radius + 80 : $radius}px
        )
        scale(${({ $active }) => ($active ? 1.2 : 1)});
    z-index: ${({ $active }) => ($active ? 100 : 1)};
    cursor: pointer;
    border-radius: 32px;
    overflow: hidden;
    box-shadow: ${({ $active }) =>
        $active
            ? '0 20px 50px rgba(0, 0, 0, 0.5)'
            : '0 10px 30px rgba(0, 0, 0, 0.3)'};
    border: ${({ $active, $CARD_BORDER_COLOR }) =>
        $active
            ? `2px solid ${$CARD_BORDER_COLOR}`
            : `1px solid ${$CARD_BORDER_COLOR}`};
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
        opacity: ${({ $active }) => ($active ? 1 : 0.6)};
        filter: ${({ $active }) =>
            $active
                ? 'none'
                : 'grayscale(30%) brightness(70%)'};
        transition: all 0.8s ease;
    }

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.1) 0%,
            transparent 50%,
            rgba(0, 0, 0, 0.2) 100%
        );
        pointer-events: none;
    }

    &:hover {
        box-shadow: 0 15px 45px rgba(0, 0, 0, 0.4);
        border-color: rgba(255, 255, 255, 0.3);
    }

    @media (max-width: 768px) {
        width: 150px;
        height: 150px;
        transform: rotateY(${({ $rotate }) => $rotate}deg)
            translateZ(
                ${({ $radiusMobile, $active }) =>
                    $active
                        ? $radiusMobile + 60
                        : $radiusMobile}px
            )
            scale(${({ $active }) => ($active ? 1.2 : 1)});
    }
`;

export const CarouselLabel = styled.div`
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    background: ${({ $CARD_BACKGROUND_COLOR }) =>
        $CARD_BACKGROUND_COLOR};
    border: 1px solid
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR};
    color: ${({ $PRIMARY_FONT_COLOR }) =>
        $PRIMARY_FONT_COLOR};
    padding: 10px 28px;
    border-radius: 20px;
    font-size: 18px;
    font-weight: bold;
    white-space: nowrap;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2),
        inset 0 0 1px 1px rgba(255, 255, 255, 0.1);
    opacity: ${({ $active }) => ($active ? 1 : 0.8)};
    transition: all 0.5s ease;
    z-index: 50;
    pointer-events: none;
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: 768px) {
        top: -35px;
        padding: 8px 20px;
        font-size: 14px;
        gap: 8px;
    }
`;

export const NavigationButton = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: ${({ $CARD_BACKGROUND_COLOR }) =>
        $CARD_BACKGROUND_COLOR};
    border: 1px solid
        ${({ $CARD_BORDER_COLOR }) => $CARD_BORDER_COLOR};
    color: ${({ $PRIMARY_FONT_COLOR }) =>
        $PRIMARY_FONT_COLOR};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 100;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

    &:hover {
        background: ${({ $isDarkMode }) =>
            $isDarkMode
                ? 'rgba(255, 255, 255, 0.1)'
                : 'rgba(255, 255, 255, 0.6)'};
        transform: translateY(-50%) scale(1.1);
    }

    ${({ position }) =>
        position === 'left'
            ? 'left: -50px;'
            : 'right: -50px;'}

    @media (max-width: 1024px) {
        ${({ position }) =>
            position === 'left'
                ? 'left: 10px;'
                : 'right: 10px;'}
    }
`;
